/*
 * トップ hero のスライドショー制御（Swiper駆動）。
 * hero.liquid が slider モード時のみ [data-hero-slider] > .swiper（Swiperインスタンス）と
 * .hero__arrow--prev / .hero__arrow--next を出力する。
 * 切替アニメーションは Swiper の virtualTranslate（自前クリップ/フェード）で実装する:
 *   - anim-fade: CSS の opacity/visibility transition に任せる（is-active の付け替えのみ）
 *   - anim-sweep: clip-path を JS でインライン駆動する
 * hero-komorebi.js の流儀（IIFE・console.debug・shopify:section:load 再初期化）に合わせる。
 */
(function () {
  'use strict';

  var DURATION = 500;
  var EASING = 'cubic-bezier(1, 0, 0, 1)';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSlider(root) {
    if (root.dataset.heroSliderInit === 'true') return;
    root.dataset.heroSliderInit = 'true';

    // お知らせカード側の .swiper を拾わないよう直下に限定する
    var swiperEl = root.querySelector(':scope > .swiper');
    if (!swiperEl) return;

    var isSweep = root.classList.contains('anim-sweep');
    var autoplay = root.dataset.autoplay === 'true';
    var speed = (parseFloat(root.dataset.speed) || 5) * 1000;
    var editorPaused = false;
    var arrows = root.querySelectorAll('.hero__arrow');

    function syncArrowColor(slide) {
      if (!slide) return;
      var colorScheme = slide.dataset.colorScheme;
      if (!colorScheme) return;

      arrows.forEach(function (arrow) {
        arrow.classList.remove('color-' + arrow.dataset.colorScheme);
        arrow.classList.add('color-' + colorScheme);
        arrow.dataset.colorScheme = colorScheme;
      });
    }

    function clearInlineClip(slide) {
      slide.style.transition = '';
      slide.style.clipPath = '';
      slide.style.webkitClipPath = '';
      slide.style.zIndex = '';
    }

    function applySweep(enterSlide, leaveSlide, forward) {
      var startClip = forward ? 'inset(0 0 0 100%)' : 'inset(0 100% 0 0)';
      var endClip = 'inset(0 0 0 0)';

      enterSlide.classList.add('is-active');
      enterSlide.style.zIndex = '3';
      enterSlide.style.transition = 'none';
      enterSlide.style.clipPath = startClip;
      enterSlide.style.webkitClipPath = startClip;

      // reflow で開始状態を確定させてから終了状態へアニメーション
      void enterSlide.offsetWidth;

      enterSlide.style.transition = 'clip-path ' + DURATION + 'ms ' + EASING + ', -webkit-clip-path ' + DURATION + 'ms ' + EASING;
      enterSlide.style.clipPath = endClip;
      enterSlide.style.webkitClipPath = endClip;

      var settled = false;
      var finish = function () {
        if (settled) return;
        settled = true;
        enterSlide.removeEventListener('transitionend', finish);
        clearInlineClip(enterSlide);
        if (leaveSlide) leaveSlide.classList.remove('is-active');
      };
      enterSlide.addEventListener('transitionend', finish);
      setTimeout(finish, DURATION + 200);
    }

    function handleTransition(swiper) {
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var previousIndex = swiper.previousIndex;
      var enterSlide = slides[activeIndex];
      var leaveSlide = typeof previousIndex === 'number' ? slides[previousIndex] : null;

      if (!enterSlide) return;

      if (!leaveSlide || leaveSlide === enterSlide) {
        enterSlide.classList.add('is-active');
        return;
      }

      if (reduce) {
        enterSlide.classList.add('is-active');
        leaveSlide.classList.remove('is-active');
        return;
      }

      if (isSweep) {
        var forward = activeIndex > previousIndex;
        if (previousIndex === slides.length - 1 && activeIndex === 0) forward = true;
        if (previousIndex === 0 && activeIndex === slides.length - 1) forward = false;
        applySweep(enterSlide, leaveSlide, forward);
      } else {
        enterSlide.classList.add('is-active');
        leaveSlide.classList.remove('is-active');
      }
    }

    var autoplayConfig = false;
    if (autoplay && !reduce) {
      autoplayConfig = { delay: speed, disableOnInteraction: false, waitForTransition: false };
    }

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      loop: false,
      rewind: true,
      speed: 500,
      virtualTranslate: true,
      grabCursor: true,
      threshold: 5,
      simulateTouch: true,
      autoplay: autoplayConfig,
      navigation: {
        prevEl: root.querySelector('.hero__arrow--prev'),
        nextEl: root.querySelector('.hero__arrow--next'),
      },
      on: {
        init: function (sw) {
          var first = sw.slides[sw.activeIndex];
          if (first) {
            first.classList.add('is-active');
            syncArrowColor(first);
          }
        },
        slideChangeTransitionStart: function (sw) {
          syncArrowColor(sw.slides[sw.activeIndex]);
          handleTransition(sw);
        },
      },
    });

    // テーマエディタ: スライド選択で該当スライド表示＋自動再生を一時停止
    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target)) return;
      var slide = e.target.closest('.swiper-slide');
      var idx = swiper.slides.indexOf(slide);
      if (idx < 0) return;
      editorPaused = true;
      if (swiper.autoplay) swiper.autoplay.stop();
      swiper.slideTo(idx);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (!root.contains(e.target)) return;
      if (!editorPaused) return;
      editorPaused = false;
      if (autoplayConfig) swiper.autoplay.start();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-hero-slider]').forEach(function (root) {
      try {
        initSlider(root);
      } catch (e) {
        console.debug('[hero-slider] init failed', e);
      }
    });
  }

  if (typeof Swiper === 'undefined') {
    window.addEventListener('load', initAll, { once: true });
  } else {
    initAll();
  }
  // エディタは設定変更でセクション DOM を差し替えるため再初期化（差替後は新要素＝init guard を通る）
  document.addEventListener('shopify:section:load', initAll);
})();
